import { render, staticRenderFns } from "./ScrollableResource.vue?vue&type=template&id=20b0b0d0&"
import script from "./ScrollableResource.vue?vue&type=script&lang=ts&"
export * from "./ScrollableResource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports